import { render, staticRenderFns } from "./TradeTable.vue?vue&type=template&id=1f8f19f2&scoped=true&"
import script from "./TradeTable.vue?vue&type=script&lang=js&"
export * from "./TradeTable.vue?vue&type=script&lang=js&"
import style0 from "./TradeTable.vue?vue&type=style&index=0&id=1f8f19f2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8f19f2",
  null
  
)

export default component.exports